"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _flags = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/flags"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _NotificationSettings = _interopRequireDefault(require("./components/NotificationSettings"));
function AppUserSettings(_ref) {
  var appState = _ref.appState,
    callbacks = _ref.callbacks,
    flags = (0, _flags.default)(_ref);
  var submitting = appState.submitting,
    currentEmployee = appState.currentEmployee,
    enums = appState.enums;
  var submitForm = callbacks.submitForm;
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "app-user-settings-container"
  }, /*#__PURE__*/_react.default.createElement(_NotificationSettings.default, {
    submitting: submitting,
    submitForm: submitForm,
    currentEmployee: currentEmployee,
    enums: enums,
    flags: flags
  }));
}
AppUserSettings.propTypes = {
  appState: _propTypes.default.shape({
    submitting: _propTypes.default.bool.isRequired,
    currentEmployee: _propTypes.default.shape({
      notification_preferences: _propTypes.default.object.isRequired
    }).isRequired,
    enums: _propTypes.default.object.isRequired
  }).isRequired,
  callbacks: _propTypes.default.shape({
    submitForm: _propTypes.default.func.isRequired
  }).isRequired,
  flags: _propTypes.default.object.isRequired
};
var _default = exports.default = AppUserSettings;
//# sourceMappingURL=AppUserSettings.js.map